import { KYMW9007Component } from './kymw9007.component';

/**
 * パスワード再設定画面の値を管理するクラス
 *
 * @export KYMW9007Model
 * @class KYMW9007Model
 */
export class KYMW9007Model {
  kYMW9007Component: KYMW9007Component;

  // ユーザID
  public userId: string = '';
}
